<template>
  <div>
    <popup-edit-location ref="popupEditLocation" />
    <div class="flex justify-between p-3">
      <p>
        Locations are physical locations in a venue such as a bar, wardrobe it.
        It may be associated with a storage.
      </p>
      <div class="flex justify-end">
        <vs-button
          icon="add"
          @click="$refs.popupEditLocation.show()"
          type="relief"
          color="primary"
          class="mr-3"
          >Add location</vs-button
        >
      </div>
    </div>
    <vs-row class="mt-4">
      <vs-col
        class="rolecard p-3"
        v-for="location in locations"
        :key="location.id"
      >
        <vs-card>
          <div slot="header">
            <vs-row vs-justify="space-between">
              <h6>{{ location.name }}</h6>
              <div>
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click="editLocation(location)"
                />
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-4"
                  @click="confirmDelete(location)"
                />
              </div>
            </vs-row>
          </div>
          <div>
            <vs-row class="mt-4">
              <vs-col vs-w="4">Name</vs-col>
              <vs-col vs-w="8"
                ><i>{{ location.name }}</i></vs-col
              >
            </vs-row>
            <vs-row class="mt-4">
              <vs-col vs-w="4">Uses storage</vs-col>
              <vs-col vs-w="8"
                ><i
                  ><code>{{
                    location.storageId
                      ? storageName(location.storageId.id)
                      : "No"
                  }}</code></i
                ></vs-col
              >
            </vs-row>
          </div>
        </vs-card>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import PopupEditLocation from "./PopupEditLocation.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    PopupEditLocation,
  },
  data() {
    return {
      removeId: "",
    };
  },
  methods: {
    async confirmDelete(tr) {
      this.removeId = tr.locationId.id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to delete this location?",
        accept: this.remove,
      });
    },
    async remove() {
      this.$vs.loading();
      await this.$store.dispatch("pos/venues/deleteLocation", {
        venueId: this.venue.id,
        locationId: this.removeId,
      });
      this.$vs.loading.close();
    },
    async editLocation(location) {
      this.$refs.popupEditLocation.show(location);
    },
  },
  computed: {
    ...mapGetters({
      venue: "pos/venues/venue",
    }),
    storageName() {
      return (id) => {
        const storage = this.venue.storages.find((s) => s.storageId.id === id);
        return storage ? storage.name : "No";
      };
    },
    locations() {
      return this.venue.locations;
    },
  },

  async mounted() {},
};
</script>


<style lang="scss" scoped>
.role-table {
  max-height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.rolecard {
  &.deactivated {
    opacity: 0.75;
  }

  min-width: 380px;
  max-width: 380px;

  .con-vs-card {
    border: 2px solid #ccc;
  }

  .vs-card--content {
    margin-bottom: 0;
  }

  .vs-card--footer {
    padding: 6px 12px;
    margin-top: 0;
    transform: none;
    background-color: #ccc;
    font-size: 0.8rem;
  }
}
</style>